module.exports = __webpack_public_path__ + "img/responsive hospitium-14.a06fd396.jpg";